import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
// import Typography from "@material-ui/core/Typography";

const MyTooltip = (props) => {
  const { title, children, navbar } = props;
  const useStylesBootstrap = makeStyles((theme) => ({
    arrow: {
      color: `#3948FF`,
      zIndex: navbar && "99",
    },
    tooltip: {
      backgroundColor: `#3948FF`,
      fontSize: "12px",
      zIndex: navbar && "99",
    },
  }));

  function BootstrapTooltip(props) {
    const classes = useStylesBootstrap();

    return <Tooltip arrow classes={classes} {...props} />;
  }

  return <BootstrapTooltip title={title}>{children}</BootstrapTooltip>;
};

export default MyTooltip;
